import {keys} from 'ts-transformer-keys';


type RequiredKeys<T> = { [K in keyof T]-? : {} extends Pick<T, K> ? never : K }[keyof T];
type RequiredOf<T> = Pick<T, RequiredKeys<T>>;


export type File = {
    id : number;
    key : string;
    name : string;

    contentType : string;
    extension : string;
    fileID : number;
    originalName : string;
    size : number;
    uploadDate : Date;

    keywords? : string;
};
export const fileProps = keys<File>();
export const requiredFileProps = keys<RequiredOf<File>>();
